const CartReducer = (state, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return { ...state, products: action.payload, loading: false };

    case 'ADD_TO_CART':
      const newCart = [...state.cart];
      const index = newCart.findIndex(item => item.id === action.payload.id);

      if (index !== -1) {
        newCart[index].cantidadEnCarrito += 1;
      } else {
        newCart.push({ ...action.payload, cantidadEnCarrito: 1 });
      }

      const cartCount = newCart.reduce((sum, item) => sum + item.cantidadEnCarrito, 0);
      const cartTotal = newCart.reduce((sum, item) => sum + item.price * item.cantidadEnCarrito, 0);

      localStorage.setItem('cart', JSON.stringify(newCart));
      localStorage.setItem('Café Total', cartCount);
      localStorage.setItem('Café Inca', cartTotal);

      return { ...state, cart: newCart, cartCount, cartTotal };

    case 'UPDATE_ITEM_QUANTITY':
      const { id, quantity } = action.payload;
      const updatedCart = state.cart.map(item =>
        item.id === id ? { ...item, cantidadEnCarrito: quantity } : item
      );

      const updatedCartCount = updatedCart.reduce((sum, item) => sum + item.cantidadEnCarrito, 0);
      const updatedCartTotal = updatedCart.reduce((sum, item) => sum + item.price * item.cantidadEnCarrito, 0);

      localStorage.setItem('cart', JSON.stringify(updatedCart));
      localStorage.setItem('Café Total', updatedCartCount);
      localStorage.setItem('Café Inca', updatedCartTotal);

      return { ...state, cart: updatedCart, cartCount: updatedCartCount, cartTotal: updatedCartTotal };

    case 'CLEAR_CART':
      localStorage.removeItem('cart');
      localStorage.removeItem('Café Total');
      localStorage.removeItem('Café Inca');
      return { ...state, cart: [], cartCount: 0, cartTotal: 0 };

    default:
      return state;
  }
};

export default CartReducer;
